import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 30000 });
export const PLATFORM_HOST = new URL(process.env.REACT_APP_BACKEND_URL).host;
export const isCustomHost = () => { const h = window.location.host; return h !== PLATFORM_HOST && !/^(localhost|127\.0\.0\.1)(:\d+)?$/.test(h); };
export const bizSlug = () => { const q = new URLSearchParams(window.location.search).get("b"); if (q) { sessionStorage.setItem("ip_biz", q); return q; } const m = window.location.pathname.match(/^\/b\/([\w-]+)/); if (m) { sessionStorage.setItem("ip_biz", m[1]); return m[1]; } return sessionStorage.getItem("ip_biz"); };
export const withBiz = (cfg) => { const b = bizSlug(); if (b && !localStorage.getItem("ip_token")) { cfg.params = { ...(cfg.params || {}), b }; } if (isCustomHost()) cfg.headers = { ...(cfg.headers || {}), "X-Portal-Host": window.location.host }; return cfg; };
api.interceptors.request.use((cfg) => {
  withBiz(cfg);
  const t = localStorage.getItem("ip_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const TZ = "UTC";
export const fmt = (iso, opts = { weekday: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) =>
  iso ? new Date(iso).toLocaleString("en-GB", { timeZone: TZ, ...opts }) : "—";
export const fmtDate = (iso, opts = { day: "numeric", month: "short" }) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { timeZone: TZ, ...opts }) : "—";
export const fmtTime = (iso) => fmt(iso, { hour: "2-digit", minute: "2-digit" });
export const dayKey = (iso) => iso.slice(0, 10);
export const toLocalInput = (iso) => (iso ? iso.slice(0, 16) : "");
export const fromLocalInput = (v) => (v ? `${v}:00+00:00` : null);

export const weekMonday = (d = new Date()) => {
  const x = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
  x.setUTCDate(x.getUTCDate() - ((x.getUTCDay() + 6) % 7));
  return x;
};
export const addDays = (d, n) => new Date(d.getTime() + n * 86400000);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!e?.response) {
    if (e?.code === "ECONNABORTED") return "The server took too long to respond — please try again.";
    return `Can't reach the SpottrOS server (${PLATFORM_HOST}). Check your connection and try again.`;
  }
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const STATUS = {
  CONFIRMED: ["ok", "Confirmed"],
  AWAITING_CONFIRMATION: ["warn", "Pending"],
  CHANGE_REQUESTED: ["bad", "Change requested"],
  COMPLETED: ["gray", "Completed"],
  CANCELLED: ["gray", "Cancelled"],
  NO_SHOW: ["bad", "No-show"],
  SCHEDULED: ["gray", "Scheduled"],
};
export const FLAG = {
  on_track: ["ok", "On track"],
  check_in: ["warn", "Check in"],
  at_risk: ["bad", "At risk"],
};
export const METRIC_TYPES = ["WEIGHT", "BODY_FAT", "SQUAT_5RM", "BENCH_5RM", "DEADLIFT_5RM", "RUN_5K", "CUSTOM"];
export const CHANNELS = ["WHATSAPP", "SMS", "EMAIL", "PUSH", "IN_APP"];
export const initials = (name = "") => name.split(" ").filter(Boolean).map((p) => p[0]).join("").toUpperCase().slice(0, 2);
export const photoUrl = (clientId, photoKey) =>
  photoKey ? `${process.env.REACT_APP_BACKEND_URL}/api/photos/${clientId}?auth=${localStorage.getItem("ip_token")}&v=${encodeURIComponent(photoKey.slice(-12))}` : null;
export const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const HL_KIND = { PR: ["ok", "PR"], MILESTONE: ["warn", "Milestone"], STREAK: ["gray", "Streak"] };
